import { FormConfig, FormField } from 'components/form/FormConfig';
import { useCallback, useMemo } from 'react';
import i18n from 'i18n';
import { renderFormikKeywordInput } from 'components/KeywordInput/KeywordInput';
import { validateEmpty } from 'utils/ValidateUtils';
import { ECSegmentType } from 'core/ecSegment/ECSegment';

const MAX_KEYWORDS = 100;

export const useSearchKeywordSegmentFields = (type: ECSegmentType): FormField[] => {

  const validateKeywordsField = useCallback((value: string[]) => {
    const error = validateEmpty(value);
    if (error) {
      return error;
    }
    if (value.length > MAX_KEYWORDS) {
      return i18n.t<string>('ecSegmentForm.errors.keywordLimit', { max: MAX_KEYWORDS });
    }
  }, []);

  const renderKeywordInput = useCallback(() => {
    return renderFormikKeywordInput('inclusion', validateKeywordsField);
  }, [validateKeywordsField]);

  const fields = useMemo(() => {
    return new FormConfig.FieldsBuilder()
      .addFormikCustom({
        label: i18n.t<string>('ecSegmentForm.labels.inclusion'),
        fieldContentWidth: '600px',
        name: 'keyworInput',
        render: renderKeywordInput
      })
      .build();
  }, [renderKeywordInput]);

  return type === ECSegmentType.SEARCH_KEYWORDS ? fields : [];
};
